import React from "react";
import PageSeo from "components/Seo/PageSeo";
import "components/Home/homeShared.css";
import "./privacy.css";

const Privacy = () => (
  <main className="privacy-page">
    <PageSeo
      title="Privacy Policy"
      description="Privacy policy for ace-gymnastics.com — how Ace Gymnastics uses website analytics and third-party services."
      path="/privacy"
      noindex
    />
    <section className="home-section privacy-page__content" aria-labelledby="privacy-heading">
      <div className="home-section__inner privacy-page__inner">
        <header className="home-section__header">
          <h1 id="privacy-heading" className="home-section__title">
            Privacy Policy
          </h1>
          <p className="home-section__subtitle">Last updated: June 1, 2026</p>
        </header>

        <div className="privacy-page__body">
          <p>
            Ace Gymnastics (“we,” “us”) operates{" "}
            <a href="https://www.ace-gymnastics.com">ace-gymnastics.com</a>. This
            policy explains how our website handles information when you visit.
          </p>

          <h2>Information we collect on this website</h2>
          <p>
            When you browse our site, we use <strong>Google Analytics 4</strong> to
            understand how visitors use the site — for example, which pages are viewed
            and which links are clicked (such as Register, program pages, or contact
            information). This helps us improve the site for families looking for
            classes and events.
          </p>
          <p>
            Google Analytics may use cookies or similar technologies and may collect
            information such as pages visited, general location (city/region), device
            type, and browser type. We do not use this data to identify you personally
            through our website analytics.
          </p>
          <p>
            Learn how Google handles data:{" "}
            <a
              href="https://policies.google.com/privacy"
              target="_blank"
              rel="noopener noreferrer"
            >
              Google Privacy Policy
            </a>
            . You can opt out of Google Analytics using the{" "}
            <a
              href="https://tools.google.com/dlpage/gaoptout"
              target="_blank"
              rel="noopener noreferrer"
            >
              Google Analytics Opt-out Browser Add-on
            </a>
            .
          </p>

          <h2>Information you provide elsewhere</h2>
          <p>
            Class registration, the parent portal, job applications, and some event
            sign-ups are handled on <strong>third-party websites</strong> (such as
            Jackrabbit Class or Google Forms), not directly on ace-gymnastics.com.
            Those services have their own privacy policies. We encourage you to review
            them when you register or apply.
          </p>

          <h2>How we use website information</h2>
          <ul>
            <li>Improve site content and navigation</li>
            <li>Understand interest in programs, events, and registration links</li>
            <li>Maintain and secure the website</li>
          </ul>
          <p>We do not sell your personal information.</p>

          <h2>Children</h2>
          <p>
            Our website is intended for parents and guardians. We do not knowingly
            collect personal information from children through site analytics. Class
            enrollment for minors is handled through our registration system by a
            parent or guardian.
          </p>

          <h2>Changes</h2>
          <p>
            We may update this policy from time to time. The “Last updated” date at
            the top will change when we do.
          </p>

          <h2>Contact us</h2>
          <p>
            Questions about this policy? Contact Ace Gymnastics:
          </p>
          <ul>
            <li>
              Email:{" "}
              <a href="mailto:office@ace-gymnastics.com">office@ace-gymnastics.com</a>
            </li>
            <li>
              Phone: <a href="tel:502-252-8512">502-252-8512</a>
            </li>
            <li>2388 New Haven Road, Bardstown, KY 40004</li>
          </ul>
        </div>
      </div>
    </section>
  </main>
);

export default Privacy;
